import React from 'react';
import { Field } from '../../../routes/Pages/Obra/ObraOrderIndex';
import { Checkbox, TextField } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';

interface FieldInputProps {
    field: Field,
    value: any;
    onChange: (value: any) => void;
}

export default function FieldInput({ field, value, onChange, ...props }: FieldInputProps) {
    switch (field.type) {
        case 'date':
            return <KeyboardDatePicker
                label={field.name}
                format="DD/MM/yyyy"
                variant="inline"
                inputVariant="outlined"
                fullWidth
                value={moment(value)}
                onChange={(date) => onChange(date?.format('YYYY-MM-DD') ?? '')}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
                invalidDateMessage="Data não definida"
                InputProps={{
                    disabled: value === '' || value === null,
                    startAdornment: <Checkbox
                        checked={value === '' || value === null}
                        onChange={(e) => {
                            if (e.target.checked) {
                                onChange('');
                            } else {
                                onChange(moment().format('YYYY-MM-DD'));
                            }
                        }}
                        color="primary"
                    />
                }}
            />
        case 'text':
        case 'multiline':
        default:
            return <TextField
                label={field.name}
                fullWidth
                variant="outlined"
                multiline={field.type === 'multiline'}
                minRows={field.type === 'multiline' ? 3 : 1}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
    }
}